<ion-app>
  @if (showOnlyRouterOutlet()) {
    <ion-router-outlet></ion-router-outlet>
  } @else {
    <ion-split-pane when="md" contentId="main-content">
      <ion-menu contentId="main-content" color="dark" class="remove-line">
        <ion-header class="main-menu-header bg-dark">
          <ion-toolbar color="dark">
            <ion-img src="img/logo/logo.svg" class="logo"></ion-img>
          </ion-toolbar>
        </ion-header>

        <ion-content color="dark">
          <ion-list class="ion-no-padding">
            <ion-item
              button
              routerLink="/dashboard"
              color="dark"
              routerDirection="root"
            >
              <ion-icon name="grid" slot="start"></ion-icon>
              <ion-label>{{ 'menu_dashboard' | translate }}</ion-label>
            </ion-item>
            <ion-item
              button
              routerLink="/installations"
              color="dark"
              routerDirection="root"
            >
              <ion-icon name="home" slot="start"></ion-icon>
              <ion-label>{{ 'menu_installations' | translate }}</ion-label>
            </ion-item>
          </ion-list>
        </ion-content>
      </ion-menu>

      <div id="main-content" class="ion-page">
        <app-header></app-header>

        <ion-content color="light" class="ion-padding ion-content-full-height">
          <ion-router-outlet id="view" [animated]="false"></ion-router-outlet>
        </ion-content>
      </div>
    </ion-split-pane>
  }
</ion-app>
